<template>
  <div class="userinformations" v-if="selectedUser !== null">
    <h3>{{ selectedUser.displayname }}'s Benutzerinformationen</h3>

    <div class="userinformations-grid">
      <UserInformationComponent title="Benutzername" :content="selectedUser.displayname" />
      <UserInformationComponent title="E-Mail Adresse" :content="selectedUser.email" />
      <UserInformationComponent title="Konto UUID" :content="selectedUser.uid" />

      <UserInformationComponent title="Permission Weight" :content="selectedUser.weight" />

      <UserInformationComponent
        title="Kontoerstellung"
        :content="
          selectedUser.creationtime == 'null'
            ? 'Unbekannt'
            : new Date(selectedUser.creationtime).toLocaleString('de-DE', dateOptions)
        "
      />
      <UserInformationComponent
        title="Letzter Login"
        :content="
          selectedUser.lastlogin == 'null'
            ? 'Niemals Angemeldet'
            : new Date(selectedUser.lastlogin).toLocaleString('de-DE', dateOptions)
        "
      />
      <UserInformationComponent
        title="Letzte Aktivität"
        :content="
          selectedUser.lastrefreshtime == 'null'
            ? 'Niemals Aktiv'
            : new Date(selectedUser.lastrefreshtime).toLocaleString('de-DE', dateOptions)
        "
      />
    </div>

    <Button
      :label="selectedUser.deactivated ? 'Konto reaktivieren' : 'Konto deaktivieren'"
      :severity="selectedUser.deactivated ? 'success' : 'danger'"
      text
      outlined
      @click="deactivationBtnTrigger"
      :disabled="
        !authStore.hasUserPermission('management.users.activation') ||
        loadingActivation ||
        selectedUser.weight >= authStore.weight
      "
    ></Button>
    <ConfirmPopup style="max-width: 25rem"></ConfirmPopup>
  </div>
</template>
<script>
import router from '../router/index.js'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import FloatLabel from 'primevue/floatlabel'
import InputSwitch from 'primevue/inputswitch'
import CreateUserDialog from './CreateUserDialog.vue'
import ConfirmPopup from 'primevue/confirmpopup'
import { RouterLink, useRouter } from 'vue-router'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import axios from 'axios'
import { config } from '../assets/config.js'
import UserInformationComponent from './UserInformationComponent.vue'
import { useAuthStore } from '@/stores/auth.js'

export default {
  components: {
    Dialog,
    Button,
    FloatLabel,
    InputText,
    InputSwitch,
    ConfirmPopup,
    UserInformationComponent
  },

  props: {
    selectedUser: Object
  },

  data() {
    return {
      authStore: useAuthStore(),

      loadingActivation: false,

      dateOptions: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',

        second: '2-digit',
        minute: '2-digit',
        hour: '2-digit'
      }
    }
  },

  methods: {
    async deactivationBtnTrigger() {
      if (!this.$props.selectedUser) return
      if (!this.$props.selectedUser.deactivated) {
        this.$confirm.require({
          target: event.currentTarget,
          message: 'Bist du dir sicher, dass du dieses Benutzerkonto deaktivieren möchtest?',
          icon: 'fa-solid fa-warning',
          acceptIcon: 'fa-solid fa-lock',
          acceptLabel: 'Deaktivieren',
          acceptClass: 'p-button-warning p-button-outlined p-button-sm',
          rejectClass: 'p-button-secondary p-button-outlined p-button-sm',
          rejectLabel: 'Abbrechen',
          rejectIcon: 'fa-solid fa-xmark',

          accept: async () => {
            await this.startDeactivation(this.$props.selectedUser.uid)
          }
        })
      } else {
        this.$confirm.require({
          target: event.currentTarget,
          message: 'Bist du dir sicher, dass du dieses Benutzerkonto reaktivieren möchtest?',
          icon: 'fa-solid fa-warning',
          acceptIcon: 'fa-solid fa-lock-open',
          acceptLabel: 'Reaktivieren',
          acceptClass: 'p-button-success p-button-outlined p-button-sm',
          rejectClass: 'p-button-secondary p-button-outlined p-button-sm',
          rejectLabel: 'Abbrechen',
          rejectIcon: 'fa-solid fa-xmark',

          accept: async () => {
            await this.startReactivation(this.$props.selectedUser.uid)
          }
        })
      }
    },
    async startDeactivation(userid) {
      this.loadingActivation = true

      let response = await axios.post(
        config.api_url + '/api/management/users/deactivate',
        {
          uid: userid
        },
        {
          headers: {
            Authorization: await getAuth().currentUser.getIdToken()
          }
        }
      )

      if (response.status == 200) {
        this.$toast.add({
          severity: 'success',
          summary: 'Konto Deaktiviert',
          group: 'tc',
          detail: 'Das Benutzerkonto wurde deaktiviert.',
          life: 5000
        })
      }

      await this.$parent.$parent.$parent.updateUsersAndSelectedUser()
      this.loadingActivation = false
    },
    async startReactivation(userid) {
      this.loadingActivation = true

      let response = await axios.post(
        config.api_url + '/api/management/users/reactivate',
        {
          uid: userid
        },
        {
          headers: {
            Authorization: await getAuth().currentUser.getIdToken()
          }
        }
      )

      if (response.status == 200) {
        this.$toast.add({
          severity: 'success',
          summary: 'Konto Reaktiviert',
          group: 'tc',
          detail: 'Das Benutzerkonto wurde reaktiviert.',
          life: 5000
        })
      }

      await this.$parent.$parent.$parent.updateUsersAndSelectedUser()
      this.loadingActivation = false
    }
  },

  async mounted() {}
}
</script>
<style lang="scss" scoped>
.userinformations {
  &-grid {
    display: grid;
    grid-template-columns: 33% 33% 33%;
    gap: 0.7rem;
    padding: 0 0 1rem 0;
  }
}
</style>
